import { IconButton, type SxProps, type Theme } from "@mui/material";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

export default function ChevronButton({
	onClick,
	sx
}: {
	onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
	sx?: SxProps<Theme>;
}) {
	return (
		<IconButton
			onClick={onClick}
			aria-label="Edit"
			sx={[
				{
					alignSelf: "stretch",
					borderRadius: 0,
					color: "text.primary"
				},
				...(Array.isArray(sx) ? sx : sx != null ? [sx] : [])
			]}
		>
			<ChevronRightIcon sx={{ fontSize: 20 }} />
		</IconButton>
	);
}
